/** @format */
import Moment from 'moment';

export function SameTrip(trip1, trip2) {
	if (trip1 == null || trip2 == null) {
		return false;
	}
	return trip1.departure === trip2.departure;
}

export function GetTravelRequest(departureDate, fromStopId, toStopId, items) {
	return {
		date: Moment(departureDate).format('yyyy-MM-DD'),
		stopIdDeparture: fromStopId,
		stopIdArrival: toStopId,
		pbe: items[0].PBE,
		article: items[0].Name,
	};
}

export function TravelDepartureComparer(t1, t2) {
	if (t1.departure < t2.departure) {
		return -1;
	}
	if (t1.departure > t2.departure) {
		return 1;
	}
	return 0;
}

export const TravelInValidCodeNotSelected = 'NotSelected';

export const isFullURL = (str) => {
	try {
		const url = new URL(str);
		return url.protocol !== '' && url.host !== '';
	} catch (error) {
		return false;
	}
};
